import {
  SET_PRODUCT_TRACK_LOADING,
  SET_PRODUCT_MOVEMENT_DATA,
  SET_PRODUCT_TRACKING_META,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  movementHistory: [],
  meta: {
    product_id: null,
    identifier: null,
    tracking_id: null,
    current_status: null,
    owner: null,
    client: null,
    customer_id: null,
  },
  loading: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_PRODUCT_MOVEMENT_DATA:
      return { ...state, movementHistory: action.payload };
    case SET_PRODUCT_TRACKING_META:
      return { ...state, meta: { ...state.meta, ...action.payload } };
    case SET_PRODUCT_TRACK_LOADING:
      return { ...state, loading: action.payload };
    default:
      return state;
  }
};
